import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

const emptySnapshot = {
    searchParams: {},
    results: [],
    hasSearched: false,
    searchFeedback: null,
    scrollY: 0,
    pendingRestore: false
};

const useClientSearchStore = create(
    persist(
        (set) => ({
            snapshot: null,
            setSnapshot: (partialSnapshot) =>
                set((state) => ({
                    snapshot: {
                        ...emptySnapshot,
                        ...(state.snapshot ?? {}),
                        ...partialSnapshot
                    }
                })),
            clearSnapshot: () => set({ snapshot: null })
        }),
        {
            name: "MFP-ClientSearchState",
            storage: createJSONStorage(() => sessionStorage)
        }
    )
);

export default useClientSearchStore;
